var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "M256,497c-19.299,0-35-15.701-35-35s15.701-35,35-35s35,15.701,35,35S275.299,497,256,497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF7F41",
    strokeMiterlimit: 10,
    d: "M256,482c-11.028,0-20-8.973-20-20s8.972-20,20-20s20,8.973,20,20 S267.028,482,256,482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "M186.312,0h-10v40h10c11.045,0,20-8.954,20-20S197.357,0,186.312,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "M326,0h10v40h-10c-11.045,0-20-8.954-20-20S314.955,0,326,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "M359.676,254.074c-7.579,0-15.006,2.056-21.471,5.941L163.5,364.839c-3.361,2.02-7.226,3.087-11.176,3.087 c-11.98,0-21.727-9.747-21.727-21.727c0-7.697,3.946-14.665,10.547-18.634l105.443-63.266c10.64-6.396,17.684-17.489,19.125-29.674 C330.116,229.652,381,175.657,381,110V40c0-19.299-15.701-35-35-35v30c2.757,0,5,2.243,5,5v70c0,52.383-42.617,95-95,95 s-95-42.617-95-95V40c0-2.757,2.243-5,5-5V5c-19.299,0-35,15.701-35,35v70c0,65.38,50.458,119.19,114.476,124.553 c-1.202,5.218-4.444,9.751-9.185,12.601L130.847,310.42c-12.49,7.51-20.249,21.22-20.249,35.779 c0,23.008,18.719,41.727,41.727,41.727c7.579,0,15.006-2.056,21.471-5.941L348.5,277.161c3.361-2.02,7.226-3.087,11.176-3.087 c11.98,0,21.727,9.747,21.727,21.727c0,7.697-3.946,14.665-10.547,18.634l-105.444,63.266C253.438,384.9,246,398.042,246,412v1.002 c-22.824,4.632-40,24.806-40,48.998c0,27.617,22.383,50,50,50s50-22.383,50-50c0-24.192-17.176-44.366-40-48.998V412 c0-7.086,3.632-13.5,9.708-17.154l105.445-63.266c12.49-7.51,20.249-21.22,20.249-35.779 C401.402,272.792,382.684,254.074,359.676,254.074z M276,462c0,11.027-8.972,20-20,20s-20-8.973-20-20s8.972-20,20-20 S276,450.973,276,462z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.d08f952ae72286d444ed95a8ca5e42c5.svg";
export { ForwardRef as ReactComponent };